import { Tabs, type TabsOptionProps } from '@sqs/rosetta-elements';
import { useTheme } from '@sqs/rosetta-styled';
import React, { ReactElement, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NAV_DASHBOARD, NAV_REPORTING, NAV_SETTINGS, NAV_USERS } from '../../const/navigation';
import { usePlatformBreakpoint } from '../../hooks/usePlatformBreakpoint';
import { useI18n } from '../../i18n';
import { RootState } from '../../stores/rootReducer';
import { useAppSelector } from '../../stores/store';
import { isInSqspOrg } from '../../utils/sqspUserUtils';
import styles from './TabNav.less';

export function TabNav() {
  const { fontSizes, space } = useTheme();
  const { isMobile } = usePlatformBreakpoint();
  const { T } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, isLoading } = useAppSelector((state: RootState) => ({
    isLoading: state.currentUser.isLoading,
    currentUser: state.currentUser.currentUser
  }));

  let currentTabFromLocation = location.pathname;
  if (location.pathname.indexOf(NAV_SETTINGS) >= 0) {
    currentTabFromLocation = NAV_SETTINGS;
  }

  const createTabOption = (label: string | ReactElement, path: string): TabsOptionProps => {
    return {
      label,
      value: path,
      sx: {
        marginLeft: space[5],
        marginRight: space[5],
        fontSize: fontSizes[4]
      }
    };
  };

  const tabOptions: TabsOptionProps[] = [
  createTabOption(
    <span>
        <T project="enterprise-dashboard">{"Dashboard"}</T>
      </span>,
    NAV_DASHBOARD
  ),
  createTabOption(
    <span>
        <T project="enterprise-dashboard">{"Settings"}</T>
      </span>,
    NAV_SETTINGS
  )];


  if (!isLoading && isInSqspOrg(currentUser)) {
    tabOptions.splice(
      1,
      0,
      createTabOption(
        <span>
          <T project="enterprise-dashboard">{"Users"}</T>
        </span>,
        NAV_USERS
      ),
      createTabOption(
        <span>
          <T project="enterprise-dashboard">{"Reporting"}</T>
        </span>,
        NAV_REPORTING
      )
    );
  }

  const [currentTab, setCurrentTab] = useState(
    currentTabFromLocation.length > 1 ? currentTabFromLocation : NAV_DASHBOARD
  );
  return (
    <Tabs
      className={styles.TabsContainer}
      options={tabOptions}
      value={currentTab}
      overflow={isMobile}
      onChange={(value: string) => {
        setCurrentTab(value);
        navigate(value);
      }} />);


}